module.exports = __webpack_public_path__ + "static/media/csv_cz.c1578315.docx";